import { NavLink } from '@festina-life/ui/actions'
import { useEffect, useEffectEvent, useState } from 'react'

import { useHook } from '../../lenteHooks'

type Props = {
  secondaryId: string
  name: string
  type: 'PersonEntity' | 'CompanyEntity'
}

export const DeathClaimsNameColumn = ({ secondaryId, name, type }: Props) => {
  const { getHomeRoute } = useHook('routing.general.useLazyHomeRoute')()
  const [homeRoute, setHomeRoute] = useState('')

  const fetchHomeRoute = useEffectEvent(() => getHomeRoute(secondaryId, type))

  // TODO: simplify this to a normal NavLink once we have consistent home pages. LIFE-8990
  useEffect(() => {
    void fetchHomeRoute().then(setHomeRoute)
  }, [])

  return <NavLink to={homeRoute}>{name}</NavLink>
}
